import { Navigate, useLocation } from "react-router-dom";
import GPDRModal from "src/components/shared/_Modals/GPDRModal/GPDRModal";
import Header from "src/components/shared/Header/Header";
import { useCheckPerm, useIsOnline } from "src/hooks";
import { onlyOnlineRoutes } from "src/mock/onlineOnlyRoutes";
import { getApiAuthData, setApiAuthData } from "src/utils";
import { Notification } from "src/utils/Notification";
import { type IApiAuthData } from "src/interfaces";
import ProtectedRouteContent from "./ProtectedRouteContent";
import { DesktopSyncProvider } from "../hooks";

export default function ProtectedRoute() {
  const { _userid } = getApiAuthData();
  const isOnline = useIsOnline();
  const checkPerm = useCheckPerm();
  const { pathname } = useLocation();

  // Login Code Handover
  // When a client uses there own API to login this code handles the auth data handover to log them via there own API
  let url = window.location.toString();
  if (url.indexOf("home") > -1 && url.indexOf("handover=true") > -1) {
    let arr = url.split("?");
    if (arr.length > 1) {
      let params = arr[1].split("&");
      let newAuth: IApiAuthData = {
        _userid: "",
        _yachtid: "",
        _session: "",
      };

      let redirect = null;
      // Iterate and set auth data
      params.map((v, k) => {
        let t = v.split("=");
        if (t[0] === "sid") {
          newAuth._session = t[1];
        } else if (t[0] === "yachtid") {
          newAuth._yachtid = t[1];
        } else if (t[0] === "userid") {
          newAuth._userid = t[1];
        } else if (t[0] === "redirect") {
          redirect = t[1];
        }
      });

      // Set authdata and redirect to home
      setApiAuthData(newAuth);
      // TODO add redirects HERE
      if (redirect) {
        return <Navigate to={redirect} replace />;
      } else {
        return <Navigate to="/home" replace />;
      }
    }
  }

  if (!_userid && !pathname.includes("/exports")) {
    return <Navigate to="/login" replace />;
  }
  if (!isOnline && onlyOnlineRoutes.some(route => pathname.includes(route))) {
    Notification(
      "Offline Redirect",
      "You appeared to be offline. Unfortunately previous view works only online",
      "yellow",
    );
    return <Navigate to="/" replace />;
  }

  if (
    (pathname === "/settings/userlist/create-user" &&
      !checkPerm("createuser")) ||
    (pathname === "/summary/reviews/create-review" && !checkPerm("review")) ||
    (pathname === "/summary/audits/create-audit" && !checkPerm("audit"))
  ) {
    Notification(
      "Unauthorized",
      "You do not have the appropriate permissions to visit this view",
      "yellow",
    );

    return <Navigate to="/" replace />;
  }

  return (
    <DesktopSyncProvider>
      <Header />
      <ProtectedRouteContent />
      <GPDRModal />
    </DesktopSyncProvider>
  );
}
